// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__ddenC","dragIcon":"SortableItem_dragIcon__1x4Bz","disabled":"SortableItem_disabled__8kTgM"};